import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { getJpdViewsServicePathPrefix } from '@atlassian/jira-polaris-lib-jpd-views-service/src/index.tsx';
import type { IssueTypeStatusesResponse } from './types.tsx';

const getSharingStatusesUrl = (viewUUID: string) =>
	`${getJpdViewsServicePathPrefix()}/public/views/${viewUUID}/sharing/issue-type-statuses`;

export const fetchSharingViewStatuses = (viewUUID: string): Promise<IssueTypeStatusesResponse> =>
	fetchJson(getSharingStatusesUrl(viewUUID));
